import { createSlice } from "@reduxjs/toolkit";

export const menuSlice = createSlice({
    name: 'menu',
    initialState: {
        active: false
    },
    reducers: {
        toggleActive: (state) => {
            return {
                ...state,
                active: !state.active
            }
        }
    }
})

export const selectMenuActive = (state) => state.menu.active;

export const { toggleActive } = menuSlice.actions;

export default menuSlice.reducer;